import { Routes } from '@angular/router';
import { OverviewView } from './features/overview/views/overview.view';
import { ToolingView } from './features/tooling/views/tooling.view';
import { WorkflowsView } from './features/workflows/views/workflows.view';
import { GuidesComponent } from './features/guides/views/guides/guides.component';

export const routes: Routes = [
    // { path: 'overview', component: OverviewView },
    // { path: '', redirectTo: '/overview', pathMatch: 'full' },
    { path: '', redirectTo: '/tooling', pathMatch: 'full' },
    {   
        path: 'tooling', 
        component: ToolingView, 
        pathMatch: 'full'
    },
    // {
    //     path: 'workflows',
    //     component: WorkflowsView,
    // },
    // {
    //     path: 'guides',
    //     component: GuidesComponent,
    // }
];
